export default {
  bind(el, binding, vnode) {
    // Define a function to handle outside click events
    const onClick = (event) => {
      // Check if the clicked element is the same element or contained within the element we want to exclude
      if (!(el === event.target || el.contains(event.target))) {
        // Call the provided method in the binding expression when an outside click is detected
        vnode.context[binding.expression](event)
      }
    }

    // Attach the click event listener to the document
    document.addEventListener('click', onClick)

    // Store the event listener on the element's dataset for later removal
    el.__vueClickOutside__ = onClick
  },

  unbind(el) {
    // Remove the click event listener from the document when the directive is unbound
    document.removeEventListener('click', el.__vueClickOutside__)
    delete el.__vueClickOutside__
  }
}
